import script from "./UPersonRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPersonRow.vue?vue&type=script&setup=true&lang=ts"

import "./UPersonRow.vue?vue&type=style&index=0&id=ef876652&lang=css"

const __exports__ = script;

export default __exports__